<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <!-- 戻るボタン　※当画面では非表示 -->
        <div class="l-top-navi__back-area"></div>

        <!-- 画面タイトル -->
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="this.displayTitle | staticMsg"></h1>
        </div>

        <!-- [ヘッダー下メニュー ボタンエリア]　※当画面では非表示 -->
        <div class="l-top-navi__function-area"></div>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol
            class="l-top-navi__progress-list"
            [attr.aria-label]="'reader.breadcrumb.navigation' | staticMsg"
            *ngIf="isBreadcrumbDisplay"
          >
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.first' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.flightSearch' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <em class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.second' | staticMsg"></span>
                <span
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.passengerInformationInput' | staticMsg"
                ></span>
              </em>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.third' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.suchAsSeatAssign' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fourth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.purchase2' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span
                  *ngIf="isPC"
                  class="reader-for-pc u-visually-hidden"
                  [innerHTML]="'reader.breadcrumb.current' | staticMsg"
                ></span>
                <span
                  *ngIf="isSP || isTB"
                  class="reader-for-sp reader-for-tab u-visually-hidden"
                  [innerHTML]="'alt.stepBar' | staticMsg : { '0': this.stepNum, '1': this.currentStepNum }"
                ></span>
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fifth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.complete' | staticMsg"></span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->

        <!--
        /=====================================================
        アクセシビリティ対応（読み上げ対策）のため、
        SP/TABの際は[ヘッダー下メニュー ボタンエリア] 、[ステップナビゲーション]の順でhtmlを出力してください
        PCの際は[ステップナビゲーション]、[ヘッダー下メニュー ボタンエリア]の順でhtmlを出力してください
        =====================================================/
        -->
      </div>
    </div>
  </div>
</div>
